/*
Copyright (C) 2020 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import { defineMessages } from 'react-intl';

const form = defineMessages({
  sellerPaymentAmountMinimum: {
    id: 'ManageSellerPaymentsModal.sellerPaymentAmountMinimum',
    defaultMessage:
      'Seller Payment Amount must be greater than or equal to zero'
  },
  sellerPaymentAmountMaximum: {
    id: 'ManageSellerPaymentsModal.sellerPaymentAmountMaximum',
    defaultMessage:
      'The Seller Payment cannot be grater than the balance of {max, number, ::currency/USD}'
  },
  sellerPaymentReasonDescriptionRequired: {
    id: 'ManageSellerPaymentsModal.sellerPaymentReasonDescriptionRequired',
    defaultMessage: 'You muse provide a description for the payment'
  }
});

const paymentMethods = defineMessages({
  revmedCredit: {
    id: 'ManageSellerPaymentsModal.paymentMethod.revmedCredit',
    defaultMessage: 'RevMed Credit'
  },
  wire: {
    id: 'ManageSellerPaymentsModal.paymentMethod.wire',
    defaultMessage: 'Wire'
  },
  ach: {
    id: 'ManageSellerPaymentsModal.paymentMethod.ach',
    defaultMessage: 'ACH'
  },
  other: {
    id: 'ManageSellerPaymentsModal.paymentMethod.other',
    defaultMessage: 'Other'
  }
});

export default { form, paymentMethods };
